import angular from 'angular';
import _ from 'lodash';

(function () {
    'use strict';
    angular.module('app.model').factory('OrderParamSvc', OrderParamSvc);

    OrderParamSvc.$inject = ['$q', 'Attribute', 'DocumentModelDA'];

    /* @ngInject */
    function OrderParamSvc($q, Attribute, DocumentModelDA) {
        var exports = {
            saveDocumentModel: saveDocumentModel,
            filterDataModal: filterDataModal,
            addAttributesToSection: addAttributesToSection,
        };

        return exports;

        ////////////////

        /**
         * Enregistrement du template de la facture
         */
        function saveDocumentModel(principalEid, documentModel, controlSets, documentAttributes, functionalType) {
            var deferred = $q.defer();
            documentModel.documentModel.attributes = _concatData(documentAttributes, true);
            var selectedControlSets = _.flatMapDeep(controlSets, res => res.filter(r => r.selected));
            documentModel.controlSets = selectedControlSets;
            DocumentModelDA.saveDocumentModel(principalEid, documentModel, functionalType).then(
                response => {
                    deferred.resolve(response);
                },
                error => {
                    deferred.reject(error);
                }
            );

            return deferred.promise;
        }

        /**
         * Cocaténation des données au format :
         * {
         * 		seller: [Atribute, Attribute],
         * 		buyer: [Atribute, Attribute],
         * 		...
         * }
         * en
         * [Atribute, Attribute, Atribute, Attribute,...]
         */
        function _concatData(orderAttributes, addOrder) {
            var concatData = [];
            for (var key in orderAttributes) {
                var attributes = orderAttributes[key];
                if (addOrder) {
                    _addOrder(attributes);
                }
                concatData = concatData.concat(attributes);
            }
            return concatData;
        }

        /**
         * Ajout de l'ordre pour les attributs d'une section non standard (triables)
         */
        function _addOrder(sectionAttributes) {
            var standardAttrs = _.filter(sectionAttributes, function (stdAttr) {
                return stdAttr.isStandard();
            });
            var maxOrder = _.maxBy(standardAttrs, 'order');
            maxOrder = maxOrder ? maxOrder.order : 0;
            var length = sectionAttributes.length;
            for (var idx = 0; idx < length; idx++) {
                var attr = sectionAttributes[idx];
                if (!attr.isStandard()) {
                    maxOrder++;
                    attr.order = maxOrder;
                }
            }
        }

        /**
         * Retourne les données de la liste des champs disponible dans la pop-up d'ajout d'un champ
         *
         * @param {LegalEntity[]} buyersList - Liste totale des clients
         *
         * @param {Attribute[]} attributes - Liste des attri buts disponible pour ce DO
         * @param {DocumentModel[]} Attributes - Liste des attributs déjà présent dans la facture
         * @param {string} sectionType - Saction dans laquelle on souhaite ajouter une données
         *
         * @return Attribute[] liste d'attributs disponible pour cette catégorie et non utilisés
         */
        function filterDataModal(attributes, Attributes, sectionType, sections) {
            // Le Attributes est trié par section, il faut supprimer cette arborescence pour obtenir
            // une liste de touts les attributs déjà présent dans la facture
            var orderAttributes = _concatData(Attributes, false);
            // On filtre déjà tous les attributs déjà présent dans la facture
            var filteredAttributes = _.differenceBy(attributes, orderAttributes, 'path');
            // On retire les aatributs composites
            filteredAttributes = _.filter(filteredAttributes, a => a.type !== 'Composite');
            // Puis on ne prend que les attributs autorisés pour la section dans laquelle
            // on souhaite ajouter l'attribut
            var allowedCategories = sections.find(section => section.id === sectionType).categories;
            return _.filter(filteredAttributes, a => allowedCategories.indexOf(a.category) !== -1);
        }

        /**
         * Permet d'ajouter une liste d'attributs dans une section.
         * Si l'attribut à ajouter a un ordre, on l'insere comme il faut
         * Si l'attribut n'a pas d'ordre défini (==-1), on l'ajoute en fin de section.
         */
        function addAttributesToSection(sectionAttrs, addedAttributes) {
            for (var i = 0; i < addedAttributes.length; i++) {
                var addedAttr = addedAttributes[i];
                if (addedAttr.order !== -1) {
                    var insertedIndex = _.sortedIndexBy(sectionAttrs, addedAttr, 'order');
                    sectionAttrs.splice(insertedIndex, 0, addedAttr);
                } else {
                    sectionAttrs.push(addedAttr);
                }
            }
        }
    }
})();
